<!-- Logo -->
<div class="logo">
  <img src="assets/images/logos/dashboard-logo-1.svg" width="35" height="35" />
  <p class="title-text">LongTail Dashboard</p>
</div>

<div class="container">
  <div class="lottie-container">
    <!-- <ng-lottie width="400px" [options]="animationOptions"></ng-lottie> -->
  </div>

  <div class="error">
    <h1>{{ 'errors.unhandled.title' | translate }}</h1>
    <p>
      {{ 'errors.unhandled.info' | translate }}
    </p>
    <p class="message">
      {{ errorMessage }}
    </p>
  </div>
</div>